import { render, staticRenderFns } from "./AccessoryTechnicalFeatures.vue?vue&type=template&id=4fed0f81&scoped=true"
import script from "./AccessoryTechnicalFeatures.vue?vue&type=script&lang=js"
export * from "./AccessoryTechnicalFeatures.vue?vue&type=script&lang=js"
import style0 from "./AccessoryTechnicalFeatures.vue?vue&type=style&index=0&id=4fed0f81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fed0f81",
  null
  
)

export default component.exports